import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';

import { NavigationComponent } from './navigation.component';
import { NavigationService } from './navigation.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DragDropModule,
    SharedModule
  ],
  declarations: [
    NavigationComponent,
  ],
  providers: [
    NavigationService
  ],
  exports: [
    NavigationComponent,
  ]
})
export class NavigationModule {}
